import { Module } from 'vuex';

import { UserHomeStats, RootState } from 'frontend/types';

const INITIAL_STATE: UserHomeStats = {
  lessons_completed: 0,
  longest_streak: 0,
  problems_attempted: 0,
  last_problem_solved_at: null,
};

const userHomeStats: Module<UserHomeStats, RootState> = {
  namespaced: true,
  state: INITIAL_STATE,
  getters: {
    longestStreak: (state: UserHomeStats): number => state.longest_streak,
    lessonsCompleted: (state: UserHomeStats): number => state.lessons_completed,
    lastProblemSolvedAt: (state: UserHomeStats): number | null => state.last_problem_solved_at,
    totalProblemsAttempted: (state: UserHomeStats): number => state.problems_attempted,
  },
  mutations: {
    setValue(state: UserHomeStats, value: UserHomeStats): void {
      Object.assign(state, value);
    },
  },
  actions: {},
};

export default userHomeStats;
